"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _emotion = require("emotion");

var rootStyleDesktop =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:13px;letter-spacing:0.1px;line-height:1.31;color:inherit;text-align:left;max-width:150px;margin-bottom:17px;");
exports.rootStyleDesktop = rootStyleDesktop;
var rootStyleMobile =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:14px;letter-spacing:0.1px;line-height:1.31;text-align:left;color:inherit;margin:14px 0px;");
exports.rootStyleMobile = rootStyleMobile;